export default __webpack_public_path__ + "static/usa-5bd2139a62f1d18a7eb84549b9847120.png";